import { render, staticRenderFns } from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=template&id=f74c6ada&scoped=true"
import script from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=script&lang=js"
export * from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=script&lang=js"
import style0 from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=style&index=0&id=f74c6ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74c6ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
